export default __webpack_public_path__ + "static/media/330_store01-jp-mobile.29e6f1b9.png";